import debounce from 'lodash/debounce';
import Dialog from '../modules/dialog.inc';
import { getItemPrice, getItemStock } from '../modules/cart.inc';

let packSizeSelect = document.querySelector('#packSize');
let qtySelect = document.querySelector('#qty');

let cartButton = document.querySelector('[data-role="addToCart"]');
let cartDetailMessage = document.querySelector('#cartDetailMessage');

let updateCartData = async () => {
    cartButton.disabled = true;
    cartButton.classList.remove(['btn-danger', 'btn-success']);

    cartButton.dataset.attributes = JSON.stringify({
        'Pack Size': packSizeSelect.value
    });

    if (qtySelect.value < 1 || qtySelect.value == '') {
        new Dialog('Please enter a quantity greater than zero.').open();
        return false;
    }

    cartButton.dataset.qty = qtySelect.value;
    delete cartButton.dataset.role;

    try {
        // Get item price
        let { subtotal } = await getItemPrice(cartButton.dataset);
        cartButton.querySelector('#totalPrice').innerHTML = subtotal;
    
        // Get stock available
        let { stockAvailable, stockMessage } = await getItemStock(cartButton.dataset);
        if (stockAvailable) {
            cartButton.disabled = false;
            cartButton.classList.add('btn-success');
            cartButton.classList.remove('btn-danger');
        } else {
            cartButton.classList.add('btn-danger');
            cartButton.classList.remove('btn-success');
        }
        
        cartDetailMessage.innerHTML = stockMessage;
    } catch (err) {
        new Dialog(err.response.data.error).open();
    }
}

let debouncedUpdateCartdata = debounce(updateCartData, 500);

packSizeSelect.addEventListener('change', updateCartData);
qtySelect.addEventListener('change', updateCartData);
qtySelect.addEventListener('keyup', debouncedUpdateCartdata);

updateCartData();